module.exports = __webpack_public_path__ + "158553c08758344f916ea817d3b441d1.MP3";